// extracted by mini-css-extract-plugin
module.exports = {"con":"intro_con__PLraK","lef":"intro_lef__2NOS2","rig":"intro_rig__1YDIK"};